/**
 * Tenant selected in the picker, sent with every API request.
 *
 * Kept in its own module (no imports) so `api/client` can read it
 * without importing a component — that would close the cycle
 * client -> TenantSelector -> api/endpoints/tenants -> client.
 *
 * This carries the *selection* only. A call aimed at one resource is
 * scoped by the backend to the tenant owning that resource, so nothing
 * here needs to know which routes address a VM.
 *
 * Slugs resolve lazily on read: the header is slug-based, and a tenant
 * can be selected before the tenant list has loaded.
 */

let activeTenantId: number | null = null;
const slugById = new Map<number, string>();

export function registerTenants(
  tenants: readonly { id: number; slug: string }[]
): void {
  tenants.forEach((t) => slugById.set(t.id, t.slug));
}

export function getActiveTenantId(): number | null {
  return activeTenantId;
}

export function getActiveTenantSlug(): string | null {
  return activeTenantId == null ? null : slugById.get(activeTenantId) ?? null;
}

export function setActiveTenant(id: number | null): void {
  activeTenantId = id;
}
